import { genView } from "./colleges.ts";

export default genView("frivolitiesJerseyNumbers", "jerseyNumbers");
